module.exports = __webpack_public_path__ + "img/fake-user-10.b1a5c740.png";